// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const DATA_CATALOG_FILES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.DATA_CATALOG_FILES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Output files': {
        systemName: 'Output files',
        displayName: 'Output files',
        kind: PipelineStepDataKind.FILE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      fileIds: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'domain',
          required: true,
          types: [
            'FILE'
          ]
        },
        minItems: 1,
        maxItems: 10
      },
      fileBaseName: {
        kind: 'string',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
